export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
export const UPDATE_PASSWORD_END = 'UPDATE_PASSWORD_END';
export const CLEAR_UPDATE_PASSWORD = 'CLEAR_UPDATE_PASSWORD';
